import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { DashboardService } from './dashboard.service';
import { AdminService } from './admin.service';
import { CommonService } from './common.service';
import { StatisticsService } from './statistics.service';
import { SettingsService } from './settings.service';

@NgModule({
  providers: [
    AuthService,
    CommonService,
    DashboardService,
    AdminService,
    StatisticsService,
    SettingsService,
  ]
})
export class ServicesModule {}
